import WallCommon from "./wallCommon";

export default class LeftWall extends WallCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'left_wall';
    this.partName = 'Left Wall';
    this.dbName = 'Left Wall';
    this.translateId = "visualizer.bathroom.walls.left_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.hasAdditionalParts = true;
    this.additionalPartPartId = "left_wall_crop";
  }

  load(dbFeature) {
    const partNumber = dbFeature.groupName === this.dbName ? 1 : 2;
    return super.load_(dbFeature, new LeftWall(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

}
